import { currentUser } from "../../../lib/currentUser";
import ErrorTrack from "../../../lib/error_track";
let currentPromosSignal = null;
// Register the current promos signal
export function registerPromosSignal(signal) {
    currentPromosSignal = signal;
}
function emitNewsletterUpdate(subscribedIds) {
    const event = {
        type: "newslettersLoaded",
        newsletters: { subscribedIds }
    };
    currentPromosSignal?.next(event);
}
// When a user subscribes to a newsletter *through* the promos engine, we need the promos-client to be
// aware of the update state. Without this, it takes 2x refreshes - resulting in the user seeing promo again on the
// next article they view < this is due to `getUserDataWhileRevalidate`
export async function updateNewsletterState(newsletterId) {
    // If user is anon, no need to update the promos-client state. If this is guard ommitted then anon users have
    // 1 x refresh of memory (stored in promos-client) before the local storage is updated from the server
    const user = await currentUser();
    if (!user.id) {
        return;
    }
    try {
        // Get current user data from localStorage, so we can include their existing subs
        const signedInUser = JSON.parse(window.localStorage.getItem("user") || "{}");
        const subscriptions = new Set(signedInUser.newsletters?.subscribedIds).add(newsletterId);
        emitNewsletterUpdate(Array.from(subscriptions));
    }
    catch (error) {
        ErrorTrack.notify(new Error(`Failed to update promo-clients state for newsletter ${newsletterId}: ${error}`));
    }
}
